module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    staticClass: "tool",
    attrs: {
      "href": "javascript:;",
      "title": "在线客服"
    },
    on: {
      "click": _vm.openAssistant
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/assistant-white.png",
      "alt": "在线客服"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00ae4598","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/tools.vue
// module id = 461
// module chunks = 1